import React from 'react'
import { useTranslation } from 'react-i18next'
import { useConfig } from '../../../contexts/ConfigContext'
import { PriceWrap, RegularPrice, SellingPrice, PriceRange } from './styles'

export const ProductPriceDisplay = ({ priceInfo, unavailable = false }) => {
  const { t } = useTranslation()
  const [configState] = useConfig()
  const currency = t(configState?.configs?.currency)

  if (!priceInfo) return null

  const { sellingPrice, regularPrice, isRange, min, max } = priceInfo
  const showRegular = regularPrice !== 0

  if (isRange) {
    return (
      <PriceWrap unavailable={unavailable}>
        {showRegular && <RegularPrice>{`${regularPrice} ${currency}`}</RegularPrice>}
        <PriceRange>{`${min} - ${max} ${currency}`}</PriceRange>
      </PriceWrap>
    )
  }

  return (
    <PriceWrap unavailable={unavailable}>
      {showRegular && <RegularPrice>{`${regularPrice} ${currency}`}</RegularPrice>}
      <SellingPrice>{`${sellingPrice} ${currency}`}</SellingPrice>
    </PriceWrap>
  )
}
